import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

class VariantsService{

    async getVariantsByModello(token, idModello, idCatalog, codiceLingua){
        return axios({
            method: 'get',
            url: API_URL + 'articoli/GetArticoliByModello',
            params: {              
                idModello: idModello,
                codiceLingua: codiceLingua,
                idCatalogo: idCatalog
            },
            headers:{
                    Authorization: 'Bearer '+ token,
                    'Content-Type': 'application/json'
            }
        }).then(
            data =>  {               
                if(data.status == 401){
                    return null;
                }
                else{
                    return data.data;
                }               
            }
        )
        .catch(error => {return error;});
    }
}

export default new VariantsService();